import { useTenantAuth } from "../context/TeanantAuthProvider";
import { ROLE_DASHBOARDS } from "./TenantProtectedRoutes";
import { Navigate } from "react-router-dom";

const TeanantPublicRoutes = ({ children }) => {
  const { loading, currentUser } = useTenantAuth();

  // if currentUser is loading show the loading screen
  if (loading || currentUser === undefined) {
    return <div>Loading...</div>;
  }

  const userDashboard = ROLE_DASHBOARDS[currentUser?.role_slug];

  // check if currentUserExists && userDashboard
  if (currentUser && userDashboard) {
    return <Navigate to={userDashboard} replace />;
  }
  // if user is not authenticated, allow access

  return children;
};

export default TeanantPublicRoutes;
